import React from 'react'
import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Foundations'
import { RaceCountdown } from '@core/Components/RaceCountdown'

export const SecondaryInfo: React.FC<{
  marketInfo: React.ReactNode
  eventStart?: string
  isBettingClosed?: boolean
}> = ({ marketInfo, eventStart, isBettingClosed }) => {
  return (
    <WrapperStyled>
      <div>{typeof marketInfo === 'string' ? <span>{marketInfo}</span> : marketInfo}</div>

      {(eventStart || isBettingClosed) && (
        <div>
          {isBettingClosed ? (
            <span>Closed</span>
          ) : (
            eventStart && (
              <RaceCountdown displaySize='1.2rem' raceStartTime={new Date(eventStart)} />
            )
          )}
        </div>
      )}
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: spacing.smx1,
  maxWidth: '100%',

  '> div': {
    boxSizing: 'border-box',
    display: 'inline-flex',
    gap: spacing.smx2,
    alignItems: 'center',
    height: '2rem',
    padding: '0 0.7rem',
    backgroundColor: 'rgba(0,0,0,0.5)',
    fontWeight: 'bold',
    lineHeight: 1,
    whiteSpace: 'nowrap',
    borderRadius: '10rem',
    minWidth: 0,
    maxWidth: 'fit-content',
  },

  '> div:first-of-type': {
    marginLeft: '-0.7rem',

    '> span:first-of-type': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      wordWrap: 'normal',
    },
  },
  '> div:last-of-type': { marginRight: '-0.7rem' },

  '> div:nth-of-type(1)': { flexGrow: 1 },
  '> div:nth-of-type(2)': { flexShrink: 0 },
})
